import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'RDS_2',
  title: 'Comment relancer le dossier de mon fournisseur ?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Vous pouvez demander au service Attestation Légale de relancer gratuitement pour vous vos sous-traitants lorsqu’un ou plusieurs documents ne sont pas à jour. Il vous suffit de cliquer sur le bouton « Relancer » situé sur la ligne de votre fournisseur.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_RDS_2/FR_RDS_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Notez qu’en dehors de vos relances, nous effectuons de notre côté des relances régulières lorsque les documents ne sont pas à jour.'
  }]
};
